import React from "react"
import loadable from "@loadable/component"
const dynamicComponents = {
  IbanCalculator: loadable(() => {
    return import("./IbanCalculator")
  }),
  IbanChecker: loadable(() => {
    return import("./IbanChecker")
  }),
}
const replaceDynamicBlocks = children => {
  for (const [i, node] of Object.entries(children)) {
    const { props: nodeProps } = node
    if (
      nodeProps &&
      "data-component" in nodeProps &&
      "data-name" in nodeProps &&
      nodeProps["data-component"] === "custom-frontend-component" &&
      nodeProps["data-name"] in dynamicComponents
    ) {
      const props = nodeProps["data-props"]
      children[i] = React.createElement(
        dynamicComponents[nodeProps["data-name"]],
        {
          key: `dynamic-component-${i}`,
          ...JSON.parse(props),
        }
      )
    }
  }
  return children
}

export default replaceDynamicBlocks
